import CIMSTable from 'components/CIMSTable'
import AsphaltMixDesignsProvider, {
  useAsphaltMixDesignsContext,
} from './AsphaltMixDesignsContext'
import { useColumns } from './hooks/useColumns'
import { useExpand } from './hooks/useExpand'
import { CSVEntity, CustomFieldClassType } from '@cims-online/shared'
import { ProjectCustomFieldsProvider } from 'components/CustomFields/ProjectCustomFieldsContext'
import { useCustom } from './hooks/useCustom'
import { useCreate } from './hooks/useCreate'
import CreateModal from './components/CreateModal'
import { useEdit } from './hooks/useEdit'

const AsphaltMixDesigns: React.VFC = () => {
  const {
    loading,
    mixDesigns,
    refetch: onReload,
  } = useAsphaltMixDesignsContext()
  return (
    <CIMSTable
      loading={loading}
      records={mixDesigns}
      rowKey={'globalId'}
      columns={useColumns()}
      actions={{
        header: {
          onReload,
          create: useCreate(),
          csv: CSVEntity.AsphaltMixDesign,
        },
        row: { custom: useCustom(), edit: useEdit() },
      }}
      expand={useExpand()}
    >
      <CreateModal />
    </CIMSTable>
  )
}

const MixDesigns: React.VFC = () => {
  return (
    <ProjectCustomFieldsProvider
      classType={CustomFieldClassType.AsphaltMixDesign}
    >
      <AsphaltMixDesignsProvider>
        <AsphaltMixDesigns />
      </AsphaltMixDesignsProvider>
    </ProjectCustomFieldsProvider>
  )
}

export default MixDesigns
